
import Vue from 'vue';
export default Vue.extend({
  props: {
    tierData: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data(): any {
    return {
      fields: [
        {
          key: 'name',
          label: 'Category',
          sortable: true,
          tdClass: 'text-capitalize',
        },
        {
          key: 'ctr',
          label: 'CTR',
          sortable: true,
          formatter(val) {
            return `${val.toFixed(2)}%`;
          },
        },
        {
          key: 'clicks',
          label: 'Clicks',
          sortable: true,
        },
        {
          key: 'impressions',
          label: 'Impressions',
          sortable: true,
        },
      ],
    };
  },
  methods: {
    rowClass(item) {
      return item.hover ? 'category-hovered' : '';
    },
    clicked(item) {
      this.$emit('clicked', item);
    },
    hover(item) {
      this.$emit('hovered', item);
    },
    unhover(item) {
      this.$emit('unhovered', item);
    },
  },
});
